export function loadWalkMeScript({ walkMeSrc }) {
  if (document.getElementById('walkmescript')) return;
  const script = document.createElement('script');
  script.id = 'walkmescript';
  script.type = 'text/javascript';
  script.async = true;
  script.src = walkMeSrc;
  window._walkmeConfig = {
    smartLoad: true,
    isContainedInIframe: true
  };
  document.head.appendChild(script);
  const referenceScript = document.getElementsByTagName('script')[0];
  referenceScript.parentNode.insertBefore(script, referenceScript);
}

export function updateFortellisWalkMeData({ userData = {}, entityData = {} }) {
  window.Fortellis_WM_Variable = {
    orgId: entityData.id || '',
    orgName: entityData.name || '',
    fortellisOrgType: entityData.fortellisDefinedType || '',
    userName: userData.name || '',
    userEmail: userData.email || ''
  };
}
